import { Text, View } from "react-native";
import { useJourney } from "../contexts/JourneyContext.js";
import GraphicBackground from "../elements/GraphicBackground.jsx";
import Toolbar from "../elements/Toolbar";

export default function ScreenCoda(props) {
  const journeyContext = useJourney();

  const stylesLocal = {
    coda: {
    color: '#fff',
    fontSize: 26,
    fontWeight: 'bold',
    marginBottom: 30,
    textAlign: "center",
  },}

  return (
    <GraphicBackground source={journeyContext.serverData.background_for_coda} >
      <View style={{marginTop: 100, marginLeft: 20, marginRight: 20, marginBottom: 40, alignItems: 'center'}}>
        <Text style={stylesLocal.coda}>The journey is now over.</Text>
        <Text style={stylesLocal.coda}>Thank you for joining us.</Text>
        <Text style={stylesLocal.coda}>The Gathering will take place at 7:30pm at Memorial Hall Morecambe, on Church Street in Poulton. You can arrive any time from 7 onwards.</Text>
        <Text style={stylesLocal.coda}>A minibus will be heading to the Gathering at 7pm, departing from More Music at 13-17 Devonshire Road.</Text>
      </View>
      <Toolbar />
    </GraphicBackground>
  )
}